import ResourceLoaderProto from "src/core/core3-depricated/app/resource-loader-proto";

const appLoaderFunction = () => import(/* webpackChunkName: "attachment-preview" */ './app');

class AttachmentPreviewLoader extends ResourceLoaderProto {

    constructor(appParams) {
        super(appParams);

        this.domElementId = appParams.containerId;
    }

    resources() {
        return [
            this._loadCSS('attachment-preview'),
            this._loadAPP(appLoaderFunction)
        ];
    }
}

module.exports = AttachmentPreviewLoader;
